const { getInsertProperties } = require('../tools/sql-tools')
const v4 = require('uuid/v4')

class FeeApi {
  constructor (pgConnection) {
    this.pgConnection = pgConnection
  }

  /**
   * @param {string} locationId
   * @param {{
   *   feeName: string,
   *   description: string,
   *   amount: number,
   *   date: string
   *  }[]} lines
   * @param {any} [pgClient]
   */
  async create (locationId, lines, pgClient) {
    const parsedLines = lines.map(l => {
      return {
        event_id: v4(),
        location_id: locationId,
        item_name: l.feeName,
        description: l.description,
        amount: l.amount,
        fee_date: l.date
      }
    })
    const { columns, values, placeholders } = getInsertProperties(parsedLines)
    const client = pgClient || this.pgConnection
    const { rows } = await client.query(`
      with args as (
        select gen_random_uuid() as transaction_id
      ),
      insert_fee_lines as (
        insert into avocado.fee (${columns})
        values ${placeholders}
        returning
          *,
          'fee' as event_type,
          tableoid::regclass::text as delivery_type,
          tableoid::regclass::text || '_' || id as sku,
          fee_date as date,
          description as notes
      )
      insert into avocado.data_stocksummaryevent (
        transaction_id,
        created_at,
        updated_at,
        id,
        event_id,
        event_type,
        delivery_type,
        location_id,
        location_fsid,
        location_fsid_sku,
        service_id,
        sku,
        sold,
        sl_sold,
        yearweek,
        date,
        notes,
        driver,
        data_source,
        _deleted
      )
      select
        transaction_id,
        now() as created_at,
        now() as updated_at,
        f.event_id,
        f.id as event_id,
        event_type,
        delivery_type,
        f.location_id::uuid as location_id,
        fsid as location_fsid,
        concat(fsid, '-', sku) as location_fsid_sku,
        fs_service_id,
        sku,
        1 as sold,
        1 as sl_sold,
        concat(extract('week' from date), '.', extract('year' from date)) as yearweek,
        date,
        f.notes,
        '' as driver,
        'fee-to-event-transform' as data_source,
        false as _deleted
      from insert_fee_lines f
      left join avocado.data_location l on l.uuid = f.location_id
      left join avocado.data_market m on m.id = l.market_id
      cross join args
      returning id as event_id, date, event_id as fee_id
    `, values)
    return rows
  }
}

module.exports = FeeApi
